import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import TeacherLayout from '../components/TeacherLayout';
import { ThemeSettingsProvider } from '../context/ThemeSettingsContext';
import Dashboard from '../pages/Dashboard';
import Assignments from '../pages/Assignments';
import Submissions from '../pages/Submissions';
import Students from '../pages/Students';
import Profile from '../pages/Profile';

// Mount this once inside your app's top-level <Routes>:
//
//   import TeacherRoutes from './routes/TeacherRoutes';
//   <Route path="/teacher/*" element={<TeacherRoutes />} />
//
// New pages later just need a new <Route> here plus an entry in
// TeacherLayout's navItems array.
const TeacherRoutes = () => (
  <ThemeSettingsProvider>
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <TeacherLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="assignments/:assignmentId/submissions" element={<Submissions />} />
        <Route path="students" element={<Students />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  </ThemeSettingsProvider>
);

export default TeacherRoutes;
